export default __webpack_public_path__ + "static/media/sticker-us.be3bd694.png";